import { AxiosRequestConfig } from "axios";
import catchAsync from "../../utils/catchAsync";
import httpsCall from "../httpsCall";
import { ResumeDetails } from "../../store/resume.store";
import { ApplicationDetails } from "../../config/ApplicantDetails";
import { getItemWithExpiry } from "../../utils/Common";

type LoginData = {
  email: string;
  password: string;
};

type RegistrationData = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  role: string;
};

type OtpData = {
  email: string;
  otp: string;
};
type ResendOtpData = {
  email: string;
}
type ForgetPasswordData = {
  email: string;
}
type CompanyData = {
  companyName : string;
  companyLogo: File
}
type tokenData = {
  refresh_token: string,
  access_token: string

}

type ImageData = {
  companyLogo: File
}


type ProfileData = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  companyName: string;
};

type OBJ_ID = string;

type UpdateTypeData = string;

export const logInUserApi = catchAsync(async (values: LoginData) => {  
  const data = await httpsCall.post(`auth/login`, values);
  return data;
});

export const registerUserApi = catchAsync(async (values: RegistrationData) => {  
  const data = await httpsCall.post(`auth/register`, values);
  return data;
});


export const verifyUserApi = catchAsync(async (values: OtpData) => {  
  const data = await httpsCall.post(`auth/verify-otp`, values);
  return data;
});

export const resendUserOTP = catchAsync(async (values: ResendOtpData) => {  
  const data = await httpsCall.post(`auth/resend-otp`, values);
  return data;
});

export const addCompany = catchAsync(async (values: CompanyData, tokenData: tokenData) => {  
  
  const createAuthHeaders = (): AxiosRequestConfig => {
    if (!tokenData) {
      throw new Error('Token not available');
    }
  
    return {
      headers: {
        'Authorization': `Bearer ${tokenData}`,
        'Content-Type': 'multipart/form-data', // Optional: Set if sending JSON
      },
    };
  };
  const config = createAuthHeaders();
  // const data = await axios.patch(`profile/profile-update`, values,config); 
  const data = await httpsCall.patchForm(`profile/profile-update`, values,config); 
  return data;
});


export const forgetPasswordApi = catchAsync(async (values: ForgetPasswordData) => {  
  const data = await httpsCall.post(`auth/forgot-password`, values);
  return data;
});

export const resendResetOTP = catchAsync(async (values: ResendOtpData) => {  
  const data = await httpsCall.post(`auth/resend-otp`, values);
  return data;
});

export const verifyResetUserOTPApi = catchAsync(async (values: OtpData) => {  
  const data = await httpsCall.post(`auth/verify-otp`, values);
  return data;
});

export const resetPasswordApi = catchAsync(async (values: OtpData) => {  
  const data = await httpsCall.patch(`auth/reset-password`, values);
  return data;
});

export const UpdateProfileImage = catchAsync(async (values: ImageData) => {  
  
  const createAuthHeaders = (): AxiosRequestConfig => {
    // let tokenDataAccess=localStorage.getItem('access_token');
    let tokenDataAccess=getItemWithExpiry('access_token');
    
    if(!tokenDataAccess)
    {
      tokenDataAccess=sessionStorage.getItem('access_token');
    }
    return {
      headers: {
        'Authorization': `Bearer ${tokenDataAccess}`,
        'Content-Type': 'multipart/form-data', // Optional: Set if sending JSON
      },
    };
  };
const config = createAuthHeaders();
  
  const data = await httpsCall.patchForm(`profile/profile-update`, values,config); 
  return data;
});


export const updateAccountDetails = catchAsync(async (values: ProfileData) => {  
  
  const data = await httpsCall.patchForm(`profile/profile-update`, values);  
  return data;
});

export const getProfileData = catchAsync(async () => {  
  
  const data = await httpsCall.get(`profile/profile-data`);  
  return data;
});

export const updateEducationJobseeker = catchAsync(async (values: ProfileData,updType: UpdateTypeData) => {  
  const data = await httpsCall.patch(`profile/`+updType, values);
  return data;
});


export const deleteEducationJobseeker = catchAsync(async (values: OBJ_ID,updType: UpdateTypeData) => {  
  const data = await httpsCall.delete(`profile/`+updType+`/delete/`+ values);
  return data;
});


//job details
export const jobDetails = catchAsync(async (JobId) => {  
  const data = await httpsCall.get(`job/job-detail/${JobId}`);
  return data;
});

//create resume
export const applyJob = catchAsync(async (values: ResumeDetails) => {  
  const data = await httpsCall.post(`job/create-resume`, values);
  return data;
});

//upload resume
export const uploadResume = catchAsync(async (values: any) => {  
  const data = await httpsCall.post(`job/seeker-apply`, values);
  return data;
});

//upload resume by Local Agency
export const uploadResumeList = catchAsync(async (values: any) => {  
  const data = await httpsCall.post(`job/agent-apply`, values);
  return data;
});

//applied details
export const appliedDetails = catchAsync(async (jobId: string) => {  
  const data = await httpsCall.get(`job/applied-details/${jobId}`);
  return data;
});

//applied job list
export const resumelistForAgent = catchAsync(async ( values) => {  
  const data = await httpsCall.post(`localagents-dashboard/get-my-resumes`, values);
  return data;
});


export const resumelistForAgentWOApplication = catchAsync(async ( values) => {  
  const data = await httpsCall.post(`localagents-dashboard/get-my-resumes-wo-applications`, values);
  return data;
});


//applied job list
export const appliedJobList = catchAsync(async ( page, search,sortKey,  sortDirection,
  itemsPerPage) => {  
  const data = await httpsCall.get(`job/applied/${page}/${itemsPerPage}`);
  return data;
});

//applied job details and applicant details 
export const appliedJobDetails = catchAsync(async ( applicationId) => {  
  const data = await httpsCall.get<ApplicationDetails>(`job/application/${applicationId}`);
  return data;
});

//job delete
export const appliedJobDelete = catchAsync(async ( applicationId) => {  
  const data = await httpsCall.delete(`job/delete-application/${applicationId}`);
  return data;
});

//applicant list as per job
export const jobApplicantList = catchAsync(async (jobId) => {  
  const data = await httpsCall.get(`job/job-applications/${jobId}`);
  return data;
});

// applicant status update
export const applicantStatusUpdate = catchAsync(async (applicationId, values) => {  
  const data = await httpsCall.patch(`job/update-application-status/${applicationId}`, values);
  return data;
});

//applicant list as per job table format 
export const jobApplicantListTable = catchAsync(async (jobId, page, search,sortKey,  sortDirection,
  itemsPerPage) => {  
  const data = await httpsCall.get(`job/job-application-list/${jobId}/${page}/${itemsPerPage}`);
  return data;
});

//applicant list as per job table format 
export const deleteApplicant = catchAsync(async (jobId) => {  
  const data = await httpsCall.delete(`job/delete-application/${jobId}`);
  return data;
});

// change password 
export const changePassword = catchAsync(async (values: {}) => {  
  const data = await httpsCall.patch(`profile/change-password`, values);
  return data;
});

// notification settings 
export const notificationSettings = catchAsync(async (values: {}) => {  
  const data = await httpsCall.patch(`profile/all/notification`, values);
  return data;
});

// notification settings 
export const readAllNotification = catchAsync(async (values: {}) => {  
  const data = await httpsCall.patch(`notification/read-all`);
  return data;
});

//delete Local Agency account
export const accountDelete = catchAsync(async ( ) => {  
  const data = await httpsCall.delete(`profile/delete-account`);
  return data;
});

//applicant list as per job and Local Agency account
export const applicantListAsPerJobAgent = catchAsync(async (jobId, page, search,sortKey,  sortDirection,
  itemsPerPage) => {  
  const data = await httpsCall.get(`localagents-dashboard/applications/${jobId}/${page}/${itemsPerPage}`);
  return data;
});

